<template>
  <div class="popup-contain">
    <div class="save-event-contain">
      <div
        class="save-this-event"
        @click.prevent.stop="singleEditLocal"
        v-if="showSingle"
      >
        <span v-if="detail.repeats === 0">Save</span>
        <span v-else>Edit this event only</span>
      </div>
      <div
        class="save-future-event"
        v-if="showFuture"
        @click.prevent.stop="futureEditLocal"
      >
        Edit future events
      </div>
      <div
        class="save-future-event"
        v-if="showAll"
        @click.prevent.stop="allEditLocal"
      >
        <span v-if="detail.repeats === 0">Save</span>
        <span v-else>Edit all events</span>
      </div>
    </div>
    <div class="cancel-contain" @click.stop.prevent="hide">Cancel</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin.js";

export default {
  mixins: [dateAndTimeMixin],
  props: {
    hide: Function, //Method to hide popup
    all: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getRepeat: "getRepeat", // Check if appointment has repeat,
      getEdit: "getEdit", // Get the edit details
      details: "getDetail", // Details about all appointments
      startRepeat: "getStartRepeat", // Get when repeat starts
      endRepeat: "getEndRepeat", // Get when repeat ends
      usePsybooksVideo: "getUsePsybooksVideo", // Check if PSYBooks video is being used
      date: "getStartRepeat", // The start date from when the appointmet starts
      time: "getStartTime" // The start time
    }),
    /**
     * Is this a repeat appointment
     */
    isRepeat() {
      return !(
        this.getRepeat.innerOrOuter === "outer" &&
        this.getRepeat.selectedIndex === 0
      );
    },
    /**
     * Id of the current appointment
     */
    id() {
      return this.getEdit.id !== 0 ? this.getEdit.id : false;
    },
    /**
     * Appointment detail for current appointment
     */
    detail() {
      return this.id && this.id in this.details ? this.details[this.id] : false;
    },
    /**
     * If edit single appointment is to be shown
     */
    showSingle() {
      if (this.all && this.isRepeat) {
        return false;
      } else if (parseInt(this.detail.repeats) === 0 && !this.isRepeat) {
        return true;
      } else if (parseInt(this.detail.repeats) === 1 && this.isRepeat) {
        return !this.compareOldRepeatToNew();
      } else {
        return false;
      }
    },
    /**
     * If edit future appointments is to be shown
     */
    showFuture() {
      if (this.all) {
        return false;
      } else if (parseInt(this.detail.repeats) === 0 && !this.isRepeat) {
        return false;
      } else if (parseInt(this.detail.repeats) === 1 && this.isRepeat) {
        return true;
      } else if (parseInt(this.detail.repeats) === 0 && this.isRepeat) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * If edit all appointments is to be shown
     */
    showAll() {
      if (parseInt(this.detail.repeats) === 0 && !this.isRepeat) {
        return false;
      } else if (parseInt(this.detail.repeats) === 1 && this.isRepeat) {
        const appTimestamp = new Date(
          this.date.year,
          this.date.month,
          this.date.dayOfMonth,
          this.time.hr,
          this.time.min
        ).getTime();
        if (this.usePsybooksVideo && appTimestamp < Date.now()) {
          return false;
        } else {
          return true;
        }
      } else if (parseInt(this.detail.repeats) === 0 && this.isRepeat) {
        return true;
      } else {
        return true;
      }
    }
  },
  methods: {
    ...mapMutations({
      setEditSingleFutureAll: "setEditSingleFutureAll" // Set if edit for one appointment, future appointment or all appointments
    }),
    ...mapActions({
      submitForm: "submitForm" // Submit the form
    }),
    /**
     * Edit single appointment
     */
    singleEditLocal() {
      this.setEditSingleFutureAll("single");
      this.submitForm();
      this.hide();
    },
    /**
     * Edit future appointments
     */
    futureEditLocal() {
      this.setEditSingleFutureAll("future");
      this.submitForm();
      this.hide();
    },
    /**
     * Edit all appointments
     */
    allEditLocal() {
      this.setEditSingleFutureAll("all");
      this.submitForm();
      this.hide();
    },
    /**
     * Compare old appointment to new changed appointment
     */
    compareOldRepeatToNew() {
      const repeat = this.getRepeat;
      const appointment = this.detail;
      let result = false;

      // Step 1: Check if repeat type has changed
      switch (appointment["repeat"]) {
        case 0:
          result =
            repeat.selectedIndex !== 0 ||
            repeat.innerOrOuter !== "inner" ||
            parseInt(repeat.custom) !==
              (isNaN(appointment["repeat_freq"])
                ? 0
                : parseInt(appointment["repeat_freq"]));

          break;

        case 1:
          result =
            repeat.selectedIndex !== 1 ||
            repeat.innerOrOuter !== "outer" ||
            parseInt(repeat.custom) !== 0;

          break;

        case 2:
          result =
            repeat.selectedIndex !== 2 ||
            repeat.innerOrOuter !== "outer" ||
            parseInt(repeat.custom) !== 0;

          break;

        case 3:
          result =
            repeat.selectedIndex !== 3 ||
            repeat.innerOrOuter !== "outer" ||
            parseInt(repeat.custom) !== 0;

          break;

        case 4:
          result =
            repeat.selectedIndex !== 1 ||
            repeat.innerOrOuter !== "inner" ||
            parseInt(repeat.custom) !==
              (isNaN(appointment["repeat_freq"])
                ? 0
                : parseInt(appointment["repeat_freq"]));

          break;

        case 5:
          result =
            repeat.selectedIndex !== 4 ||
            repeat.innerOrOuter !== "outer" ||
            parseInt(repeat.custom) !== 0;

          break;

        case 6:
          result =
            repeat.selectedIndex !== (appointment["repeat_by"] === 0 ? 2 : 3) ||
            repeat.innerOrOuter !== "inner" ||
            parseInt(repeat.custom) !==
              (isNaN(appointment["repeat_freq"])
                ? 0
                : parseInt(appointment["repeat_freq"]));
          break;

        case 7:
          result =
            repeat.selectedIndex !== 4 ||
            repeat.innerOrOuter !== "inner" ||
            parseInt(repeat.custom) !==
              (isNaN(appointment["repeat_freq"])
                ? 0
                : parseInt(appointment["repeat_freq"]));

          break;
      }

      // Check if start repeat or end repeat has been changed
      if (result === false) {
        result =
          this.formatDate({
            dayOfMonth: this.startRepeat.dayOfMonth,
            month: this.startRepeat.month,
            year: this.startRepeat.year
          }) !== appointment["starts_from"] ||
          (this.formatDate({
            dayOfMonth: this.endRepeat.dayOfMonth,
            month: this.endRepeat.month,
            year: this.endRepeat.year
          }) !== appointment["end_on"] &&
            appointment["end_on"] !== "0000-00-00");
      }

      // Step 3: Return result for showing the options
      return result;
    }
  }
};
</script>
